import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import { AccordionItem } from '../Accordion/Accordion'
import Markdown from '../Markdown/Markdown'
import styles from './Campaign.module.scss'
import Button from '../ui/Button/Button'
import { isArabic } from '../../utils'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'

const CampaignFaqs = ({ title, questions, seeMore, avoidRtl }) => {
  let navigate = useNavigate()
  const { language } = useLanguage()
  const [activeIndex, setActiveIndex] = useState(null)

  useEffect(() => {
    setActiveIndex(null)
  }, [])

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  const handleNavigation = (url, isExternal) => {
    if (isExternal) window.open(url, '_blank', 'noopener,noreferrer')
    else navigate(url)
  }

  return (
    <>
      {questions && questions?.length ? (
        <div className={classNames('page-container', styles['faqsContainer'])}>
          {title && (
            <div
              className={classNames(
                styles['faqTitle'],
                !avoidRtl && isArabic(language?.code)
                  ? styles['faqTitle_ar']
                  : ''
              )}
            >
              {title}
            </div>
          )}
          <section className={styles['faq-section']}>
            <div className={styles.container}>
              <div className={styles.accordion}>
                {questions?.map((item, index) => (
                  <AccordionItem
                    key={'faq' + item?.id}
                    question={item.question}
                    isOpen={activeIndex === index}
                    onClick={() => handleClick(index)}
                  >
                    <Markdown
                      content={item.answer}
                      className={styles.faqsMarkdown}
                    />
                  </AccordionItem>
                ))}
              </div>
            </div>
          </section>
          {seeMore && seeMore?.label && (
            <div className={styles['faq-seemore']}>
              <Button
                aria-label={seeMore?.label}
                classname={styles.links}
                buttonDetails={seeMore}
                text={seeMore?.label}
                handleClick={() =>
                  handleNavigation(seeMore?.path, seeMore?.isExternal)
                }
              />
            </div>
          )}
        </div>
      ) : null}
    </>
  )
}

export default CampaignFaqs
